const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/store.ts';
import { IActionHandlersMap, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { IselectECheckin, SET_SELECTED_ECHECKIN } from './actions';
import { PatAppStoreState } from 'App/store/setup/rootReducer';

const KEY_SELECTED_ECHECKIN = 'selectedECheckin';

const handleSetSelectedECheckin = (state: ReducerState, action: IselectECheckin) => {
    return state.set(KEY_SELECTED_ECHECKIN, { fallNr: action.caseNumber, tKey: action.tKey });
};

const handlers: IActionHandlersMap = {
    [SET_SELECTED_ECHECKIN]: handleSetSelectedECheckin,
};

export const eCheckinEditorReducer = makeReducer(handlers);

// SELECTORS

export const selectSelectedECheckin = (state: PatAppStoreState) => state.eCheckinEditor.get(KEY_SELECTED_ECHECKIN);
